import PropTypes from 'prop-types';
import { gridsNames } from '../../../enums/gridsNames';
import { filterTypes } from 'infrastructure/js/enums/filterTypes';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import LabelWithTooltipCell from '../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import useLabels from 'infrastructure/js/hooks/useLabels';
import {EntityPropertyTypes} from '../../../enums/entityPropertyTypes';
import EntityIdCell from '../../Common/CustomGridCells/EntityIdCell/entityIdCell';
import {navigationStates} from '../../../enums/navigationStates';
import {enumTypes, getEnumLabel} from '../../../utils/enumHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import CheckMarkCell from '../../Common/CustomGridCells/CheckMarkCell/checkMarkCell';

import './shipmentLotsGrid.scss';

const filterConfig = [
  { fieldName: 'name', filterName: 'lotName' },   //TODO: L COC SUM - use correct filters
  { fieldName: 'status', filterName: 'lotStatus', getOptions: true },
  { fieldName: 'coc.name', filterName: 'cocName', getOptions: false }, //TODO: L COC SUM - check to make this column sortable
  // { fieldName: 'hasAttachments', filterName: 'hasAttachments', getOptions: false },
];

export default function ShipmentLotsGrid( {actions} ) {
  const labels = useLabels('mat.grid.');

  const columnsConfig = [
    {
      fieldName: 'name',
      title: labels.get('columns.lotId.title'),
      filterType: filterTypes.MULTI_SELECT_ASYNC,
      filterName: 'lotName',
      fetchConfig: {
        entityType: EntityPropertyTypes.LOT_NAME,     //TODO: L COC SUM - brings all Lots, not only for this shipment
        action: actions.fetchEntities,
      },
      columnOptions: {
        cellComponent: EntityIdCell,
        valueGetter: (params) => ({
          id: params.data.id,
          label: params.data.name,
          type: navigationStates.LOT,
        }),
      },
    },
    ...( PermissionManager.isCoCEnabled() ? [
    {
      fieldName: 'status',
      title: labels.get('columns.status.title'),
      filterType: filterTypes.MULTI_SELECT,
      filterName: 'lotStatus',
      columnOptions: {
        cellComponent: LabelWithTooltipCell,
        valueGetter: (params) => {
          return params.data?.status ? getEnumLabel(enumTypes.LOT_STATUS)(params.data?.status) : '';
        }
      },
    },
    {
      fieldName: 'coc.name',
      title: labels.get('columns.cocDetails.title'),
      filterType: filterTypes.NONE,
      columnOptions: {
        sortable: false,
        cellComponent: EntityIdCell,
        valueGetter: (params) => {
          return {
            id: params.data?.coc?.id,
            // label: params.data?.coc?.name ?? '',
            label: params.data?.coc?.name ? labels.get('columns.cocDetails.title') : '',
            type: navigationStates.COC,
          };
        }
      },
    }] : []),
    {
      fieldName: 'hasAttachments',
      title: labels.get('columns.attachments.title'),
      filterType: filterTypes.NONE,
      columnOptions: {
        sortable: false,
        cellComponent: CheckMarkCell,
      },
    },

  ];

  return (
    <div className="shipment-lots-grid">
      <Grid gridName={gridsNames.SHIPMENT_LOTS}
            columnsConfig={columnsConfig}
            filterConfig={filterConfig}
            actions={actions}
            gridProps={
              {
                checkboxSelection: false
              }
            }
      />
    </div>
  );
}

ShipmentLotsGrid.propTypes = {
  actions: PropTypes.object.isRequired,
};
